
import { CustomArray } from "../../../common/CustomArray";
import { SegmentItem } from "./SegmentItem";
import { ArrayUtility } from "../../../common/ArrayUtility";
import { SegmentLineItems } from "./SegmentLineItems";
import { SegmentType } from "./SegmentType";

export class SegmentItems extends CustomArray {

	constructor() {
		super();
	}
	
	/**
	 * 获取第一段类型
	 */
	getFirstSegmentType()
	{	
		if(this.objects.length>0)
		{
			return this.objects[0].itemType;
		}
		else
		{
			return null;
		}
	}


	/**
	 * 通过类型分类
	 */
	classifyByType() {
		let dicClassify = new Array();
		let types = new Array();
		let tempSegmentItem = null;

		let tempItemType = null;
		for (let tempIndex = 0; tempIndex < this.objects.length; tempIndex++) {
			tempSegmentItem = this.objects[tempIndex];
			tempItemType = tempSegmentItem.itemType;

			//如果没有包含该名称
			if (types.indexOf(tempItemType) == -1) {

				types.push(tempItemType);
				dicClassify[tempItemType] = new SegmentItems();
			}
			dicClassify[tempItemType].push(tempSegmentItem);
		}

		return dicClassify;
	}

	getEndStations() {
		let stations = new Array();

		let tempItem = null;
		let tempStation = null;
		for (let tempIndex = 0; tempIndex < this.objects.length; tempIndex++) {
			tempItem = this.objects[tempIndex];
			if (!tempItem) continue;
			tempStation = tempItem.stationEnd;
			if (tempStation) {
				stations.push(tempStation);
			}
		}

		return stations;
	}

	/**
	 * 获取公共交通总数
	 */
	getTransportCount()
	{	
		let transportCount =0;

		let tempItem = null;
		for (let tempIndex = 0; tempIndex < this.objects.length; tempIndex++) {
			tempItem = this.objects[tempIndex];
			if (!tempItem) continue;
			if(tempItem.isTransport())
			{
				transportCount=+1;
			}
		}
		
		return transportCount;
	}


	/**
	 * 获取线段线项数组
	 */
	getSegmentLineItems() {
		let lineItems = new SegmentLineItems();

		let tempSegmentItem = null;
		let tempLineItems = null;
		for (let tempIndex = 0; tempIndex < this.objects.length; tempIndex++) {
			tempSegmentItem = this.objects[tempIndex];
			tempLineItems = tempSegmentItem.lines.objects;
			lineItems.pushMulti(tempLineItems);
		}

		return lineItems;
	}

	filterBySegmentTypes(segmentTypes) {
		let findItems = new Array();
		if (!segmentTypes) return findItems;


		let tempItem = null;
		let tempType = null;
		for (let tempIndex = 0; tempIndex < this.objects.length; tempIndex++) {
			tempItem = this.objects[tempIndex];
			tempType = tempItem.itemType;
			if (tempType && segmentTypes.indexOf(tempType) > -1) {
				findItems.push(tempItem);
			}
		}

		return findItems;
	}


	removeTransferInSubwayItems() {
		let tempItem = null;
		for (let tempIndex = 0; tempIndex < this.objects.length; tempIndex++) {
			tempItem = this.objects[tempIndex];
			if (tempItem.itemType === SegmentType.TransferInSubway) {
				this.objects.splice(tempIndex, 1);
				tempIndex = tempIndex - 1;
			}
		}

	}


	/**
	 * 获取线段线的所有点
	 */
	getSegmentLinePoints() {
		let pnts = new Array();

		let tempSegment = null;
		let tempPnts = null;
		for (let tempSegmentIndex = 0; tempSegmentIndex < this.objects.length; tempSegmentIndex++) {
			tempSegment = this.objects[tempSegmentIndex];
			tempPnts = tempSegment.lines.getPoints();
			ArrayUtility.addTargetToOri(pnts, tempPnts);
		}

		return pnts;
	}

	/**
	 * 设置站点信息
	 */
	setStationInfo() {
		let itemCount = this.objects.length;

		let curItem = null;
		let nextItem = null;
		let curItemType = null;
		let nextItemType = null;
		for (let tempIndex = 0; tempIndex < itemCount - 1; tempIndex++) {
			curItem = this.objects[tempIndex];
			nextItem = this.objects[tempIndex + 1];

			curItemType = curItem.itemType;
			nextItemType = nextItem.itemType;

			//设置线段类型
			if (curItemType === SegmentType.Bus
				|| curItemType === SegmentType.Subway
				|| curItemType === SegmentType.TransferInSubway) {
				curItem.stationEnd.segmentType = curItemType;
			}
			else if (curItemType === SegmentType.Walk) {
				curItem.stationEnd.segmentType = nextItemType;
			}

			if (tempIndex === 0) {
				curItem.stationStart.isLinePlanStart = true;
			}
			else if (tempIndex === itemCount - 2) {
				nextItem.stationEnd.isLinePlanEnd = true;
			}
		}
	}

	/**
	 * 设置线段线项信息
	 */
	setSegmentLineItemInfo()
	{	
		let itemCount = this.objects.length;

		let curItem = null;
		let nextItem = null;
		let curItemType = null;
		// let nextItemType = null;
		let curSegmentLine = null;
		// let nextSegmentLine = null;
		for (let tempIndex = 0; tempIndex < itemCount - 1; tempIndex++) {
			curItem = this.objects[tempIndex];
			nextItem = this.objects[tempIndex + 1];

			curItemType = curItem.itemType;
			// nextItemType = nextItem.itemType;

			//设置line信息
			if (curItemType === SegmentType.TransferInSubway) {
				if (curItem && curItem.lines && curItem.lines.objects.length > 0) {
					curSegmentLine = curItem.lines.objects[0];
					if (!curSegmentLine.segmentStationCount) {
						if (nextItem && nextItem.lines && nextItem.lines.objects.length > 0) {
							curSegmentLine.segmentStationCount = nextItem.lines.objects[0].segmentStationCount;
						}
					}
				}
			}
		}

	}


	static GetSegments(jsonItems) {
		let segmentItems = null;
		if (jsonItems == null) return segmentItems;
		segmentItems = new SegmentItems();

		let jsonItemCount = jsonItems.length;

		let tempItem = null;
		for (let tempIndex = 0; tempIndex < jsonItemCount; tempIndex++) {
			tempItem = SegmentItem.GetSegmentItem(jsonItems[tempIndex]);
			segmentItems.push(tempItem);
		}

		//设置站点信息
		segmentItems.setStationInfo();
		//设置线段线项信息
		segmentItems.setSegmentLineItemInfo();
		
		return segmentItems;
	}


}//end SegmentItems

